import { useSocketStore } from '@host/realtime'
import { Avatar, Container, Text } from '@prismeet/react'

import { CONNECTION_TEXT, ONLINE_TITLE, TRENDS_TITLE } from './constants'
import styles from './index.module.scss'

/**
 * Правая колонка.
 *
 * Появляется только на широких экранах: это вспомогательный контекст,
 * и отбирать под него место у ленты на ноутбуке не за что.
 *
 * Тренды и «кто в сети» показаны пустыми состояниями, а не выдуманными
 * данными: их источник — микрофронт соцсети, которого может не быть.
 * Рисовать правдоподобную выдумку в каркасе — верный способ потом
 * не заметить, что реальные данные так и не подключили.
 */
export function RightAside() {
  const status = useSocketStore((state) => state.status)
  const latencyMs = useSocketStore((state) => state.latencyMs)

  return (
    <aside className={styles.aside}>
      <div className={styles.asideStack}>
        <Container surface="raised" radius="2xl" padding={4} className={styles.card}>
          <Text as="h2" variant="label" weight="semibold">
            {TRENDS_TITLE}
          </Text>
          <Text variant="caption" tone="tertiary">
            Тренды придут из микрофронта соцсети, как только он будет подключён.
          </Text>
        </Container>

        <Container surface="raised" radius="2xl" padding={4} className={styles.card}>
          <Text as="h2" variant="label" weight="semibold">
            {ONLINE_TITLE}
          </Text>
          <div className={styles.person}>
            <Avatar name="Никого" size="sm" presence="offline" labelledOutside />
            <span className={styles.personText}>
              <Text variant="caption" tone="tertiary">
                Список появится, когда включится реальное время
              </Text>
            </span>
          </div>
        </Container>

        <Container surface="sunken" radius="2xl" padding={3} className={styles.card}>
          <div className={styles.connection}>
            <span className={styles.connectionDot} data-status={status} aria-hidden="true" />
            <Text variant="caption" tone="secondary">
              {CONNECTION_TEXT[status]}
            </Text>
          </div>
          {latencyMs !== null ? (
            <Text variant="caption" tone="tertiary" numeric>
              Задержка {latencyMs} мс
            </Text>
          ) : null}
        </Container>
      </div>
    </aside>
  )
}
